__turbopack_context__.v({
  "banner": "coupon-banner-module-scss-module__PACySG__banner",
  "banner-bg-info": "coupon-banner-module-scss-module__PACySG__banner-bg-info",
  "banner-bg-success": "coupon-banner-module-scss-module__PACySG__banner-bg-success",
  "close-button": "coupon-banner-module-scss-module__PACySG__close-button",
  "content": "coupon-banner-module-scss-module__PACySG__content",
  "placeholder": "coupon-banner-module-scss-module__PACySG__placeholder",
});
